/**
 * A hook to return full article data.
 *
 * > **💡 NOTE**: this doesn't return any partially fetched articles so it can only be used on an article page.
 *
 * @module
 */
import { useContext } from 'react';
import { ArticleContext } from '../contexts';
/**
 *
 * # useArticle
 *
 * Usage example:
 *
 * ```javascript
 * import useArticle from "@elevio/kb-kit/lib/hooks/useArticle";
 *
 * function MyArticlePage() {
 *   const article = useArticle();
 *   console.log(article); // IArticle | undefined
 *
 *   return (
 *     ...
 *   )
 * }
 * ```
 */
export default function useArticle() {
    const article = useContext(ArticleContext);
    return article;
}
//# sourceMappingURL=useArticle.js.map